import * as React from 'react';
import styled from 'styled-components';

export interface Step {
  number: number;
  title: string;
}

export interface ProgressBwV2Props {
  steps: Step[];
  currentStepNumber: number;
  currentStepProgress?: number;
}

const ProgressStepsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 4px;
`;

const StepProgress = styled.div<{ progress: number }>(
  ({ progress }) => `
  width: 100%;
  border-radius: 50px;
  height: 4px;
  background: linear-gradient(to right, #3156FF ${progress}%, #F2F4F7 ${progress}%);
`
);

const StepTitle = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3156ff;
  @media only screen and (max-width: 480px) {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
  }
`;

const StepTitleMobile = styled.div`
  margin-top: 4px;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #3156ff;
  display: none;
  @media only screen and (max-width: 480px) {
    display: flex;
  }
`;

/**
 * @deprecated Use `Stepper` component instead
 */
export const ProgressBwV2: React.FC<ProgressBwV2Props> = React.memo(({ steps, currentStepNumber, currentStepProgress }) => {
  const currentStep = React.useMemo(
    () => steps.find((step) => step.number === currentStepNumber),
    [steps, currentStepNumber]
  );
  return (
    <>
      <ProgressStepsWrapper>
        {steps.map((step) => {
          let progress = 0;
          if (step.number < currentStep.number) {
            progress = 100;
          } else if (step.number === currentStep.number) {
            progress = currentStepProgress || 100;
          }
          return (
            <StepWrapper key={step.number}>
              <StepProgress progress={progress} />
              {step.number === currentStepNumber && <StepTitle>{step.title}</StepTitle>}
            </StepWrapper>
          );
        })}
      </ProgressStepsWrapper>
      <StepTitleMobile>
        <span>{currentStep.title}</span>
      </StepTitleMobile>
    </>
  );
});
